<template lang="pug">
  b-container(fluid)
    b-card
      template(#header)
        .mb-0.pb-0.d-flex.justify-content-between
          .p(v-if="view_title") {{view_title}}
          slot(name="title")
          .text-info(v-if="has_message") {{message}}
          .text-danger(v-if="!busy && has_error") {{error}}
          b-spinner.mt-1(small variant="secondary" v-show="busy")
          .p
            b-button(size="sm" variant="light" @click="$router.go(-1)")
              b-icon-arrow-left-short
      b-card-text
        slot

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Base',

  props:{
    view_title: String,
  },

  data(){
    return {};
  },

  computed: {
    ...mapGetters(['message','error','busy','has_error','has_message',])
  },
}
</script>
